module.exports = __webpack_public_path__ + "media/cover.6174e3db.mp4";